<ra-modal
    [title]="'document.edit.imageDateModal.title' | translate"
    [size]="'small'"
    (close)="close.emit()">

    <div class="date-body">
        <label class="date-label" for="image-date-input">
            {{ 'document.edit.imageDateModal.label' | translate }}
        </label>

        <!-- Input com o estilo do DS; o calendário é o datepicker do Material,
             aberto pelo clique em qualquer ponto do campo. -->
        <button type="button" class="date-input" (click)="picker.open()">
            <span [class.placeholder]="!selectedDate()">
                {{ selectedDate() ? (selectedDate() | date: 'shortDate') : ('document.edit.imageDateModal.placeholder' | translate) }}
            </span>
            <mat-datepicker-toggle [for]="picker" />
        </button>

        <!-- Input invisível: âncora do datepicker (posiciona o popup no campo acima). -->
        <input
            id="image-date-input"
            class="date-anchor"
            [matDatepicker]="picker"
            [value]="selectedDate()"
            (dateChange)="onDateChange($event)"
            tabindex="-1"
            aria-hidden="true"
        />
        <mat-datepicker #picker />

        <div class="date-actions">
            <ra-button
                [label]="'common.cancel' | translate"
                [type]="'primary-outline'"
                (click)="close.emit()"
            />
            <ra-button
                [label]="'document.edit.imageDateModal.confirm' | translate"
                [disabled]="!selectedDate()"
                (click)="onConfirm()"
            />
        </div>
    </div>
</ra-modal>
